/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface ValidateAccessRightsProfiles$Request {
    profileName: string;
}

export interface ValidateAccessRightsProfiles$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateAccessRightsProfilesRequest = createAction<PayloadData<void, ValidateAccessRightsProfiles$Request>>('VALIDATE_ACCESS_RIGHTS_PROFILES__VALIDATE_ACCESS_RIGHTS_PROFILES__REQUEST');
export const validateAccessRightsProfilesSuccess = createAction<PayloadData<void, ValidateAccessRightsProfiles$Request>>('VALIDATE_ACCESS_RIGHTS_PROFILES__VALIDATE_ACCESS_RIGHTS_PROFILES__SUCCESS');
export const validateAccessRightsProfilesFailure = createAction<PayloadData<Error, ValidateAccessRightsProfiles$Request, true>>('VALIDATE_ACCESS_RIGHTS_PROFILES__VALIDATE_ACCESS_RIGHTS_PROFILES__FAILURE');

export const validateAccessRightsProfilesActions = [
    validateAccessRightsProfilesRequest,
    validateAccessRightsProfilesSuccess,
    validateAccessRightsProfilesFailure
] as const;

/**
 * @param {string} meta.profileName
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateAccessRightsProfiles = (meta: ValidateAccessRightsProfiles$Request, config?: ValidateAccessRightsProfiles$Config) => {
    const TRANSPORT_GET_PARAMS = {
        profileName: meta.profileName,
    };
    return {
        CALL_API: {
            types: validateAccessRightsProfilesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/profiles/validations`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

